export default __webpack_public_path__ + "static/media/1817.d70fa209.png";